import React, { useCallback, useState } from "react";

import Button, { ButtonTypes } from "../../../../components/Button";
import {
  InstrumentFixDraft,
  InstrumentFixEditor,
  InstrumentFixSection,
  withFixSection,
} from "../../components/InstrumentEditor";
import { useQueueDraft } from "../hooks/useQueueDraft";
import { DraftNotice } from "../../styles";
import { InstrumentFixDetailProps } from "../types";

export const InstrumentFixDetail: React.FC<InstrumentFixDetailProps> = ({
  fix,
  isSubmitting,
  errors,
  onSaveCountry,
  onRepairListing,
  onUseManualPricing,
  onClearError,
}) => {
  const [draft, updateDraft] = useQueueDraft("instrument", fix.key);
  const [revision, setRevision] = useState(0);

  const handleDraftChange = useCallback(
    <S extends InstrumentFixSection>(
      section: S,
      value: InstrumentFixDraft[S] | null,
    ) => updateDraft((current) => withFixSection(current, section, value)),
    [updateDraft],
  );
  const handleDiscard = () => {
    updateDraft(() => null);
    setRevision((current) => current + 1);
    onClearError();
  };

  const notice = draft && (
    <DraftNotice>
      Unsaved draft · kept while browsing
      <Button
        type={ButtonTypes.link}
        disabled={isSubmitting}
        onClick={handleDiscard}
      >
        Discard draft
      </Button>
    </DraftNotice>
  );

  return (
    <InstrumentFixEditor
      key={revision}
      instrument={fix.instrument}
      needsPricing={fix.needsPricing}
      isSubmitting={isSubmitting}
      errors={errors}
      drafts={draft}
      notice={notice}
      onDraftChange={handleDraftChange}
      onSaveCountry={onSaveCountry}
      onRepairListing={onRepairListing}
      onUseManualPricing={onUseManualPricing}
    />
  );
};
